export default __webpack_public_path__ + "static/media/icon_help.616e1ae1.svg";